import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { gtag } from 'ga-gtag';

const SignUp = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();

    const [redirectToHome, setRedirectToHome] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {redirectToHome ? (
                <Redirect to="Home"></Redirect>
            ) : (
                <Box sx={{ margin: '20px auto', maxWidth: '900px' }}>
                    <Grid container>
                        {/* <Grid
                            item
                            xs={12}
                            sm={6}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '20px 0px',
                            }}
                        >
                            <Box
                                sx={{
                                    boxShadow: '2px 2px 15px 0 #b3bac7',
                                    padding: '20px',
                                    maxWidth: '300px',
                                    borderRadius: '10px',
                                    backgroundColor: '#FFF',
                                }}
                            >
                                <Box sx={{ padding: '10px' }}>
                                    <Chip label="Teacher Profile" />
                                </Box>
                                <Typography
                                    variant="h5"
                                    sx={{ height: '64px' }}
                                >
                                    Sign Up as a Relief Teacher
                                </Typography>
                                <Box sx={{ margin: '10px 0px' }}>
                                    Join the airTeachr platform as a Casual
                                    Relief Teacher
                                </Box>
                                <Box>
                                    <Button
                                        variant="outlined"
                                        onClick={() =>
                                            loginWithRedirect({
                                                scope: `${process.env.REACT_APP_scope} teacherProfile`,
                                                display: 'popup',
                                                screen_hint: 'signup',
                                                redirectUri: `${process.env.REACT_APP_hostUrl}`,
                                                appState: {
                                                    'type': 'teacher',
                                                    'returnTo':
                                                        '/home?type=teacher',
                                                },
                                            })
                                        }
                                    >
                                        Teacher Sign Up
                                    </Button>
                                </Box>
                            </Box>
                        </Grid> */}

                        <Grid
                            item
                            xs={12}
                            sm={6}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '20px 0px',
                            }}
                        >
                            <Box
                                sx={{
                                    boxShadow: '2px 2px 15px 0 #b3bac7',
                                    padding: '20px',
                                    maxWidth: '300px',
                                    borderRadius: '10px',
                                    backgroundColor: '#FFF',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography
                                    variant="h1"
                                    sx={{
                                        height: '64px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    Teacher
                                </Typography>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        height: '64px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    Sign Up as a Relief Teacher
                                </Typography>
                                <Box sx={{ margin: '16px 0px' }}>
                                    Join the airTeachr platform as a Casual
                                    Relief Teacher
                                </Box>
                                <Box>
                                    <Button
                                        variant="outlined"
                                        onClick={async () => {
                                            await gtag('event', 'conversion', {
                                                'send_to':
                                                    'AW-11074738954/t2MACK658ogYEIq27KAp',
                                                'event_callback':
                                                    window.location,
                                            });
                                            await loginWithRedirect({
                                                scope: `${process.env.REACT_APP_scope} teacherProfile`,
                                                display: 'popup',
                                                screen_hint: 'signup',
                                                redirectUri: `${process.env.REACT_APP_hostUrl}`,
                                                appState: {
                                                    'type': 'teacher',
                                                    'returnTo':
                                                        '/home?type=teacher',
                                                },
                                            });
                                        }}
                                    >
                                        Teacher Sign Up
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            sm={6}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '20px 0px',
                            }}
                        >
                            <Box
                                sx={{
                                    boxShadow: '2px 2px 15px 0 #b3bac7',
                                    padding: '20px',
                                    maxWidth: '300px',
                                    borderRadius: '10px',
                                    backgroundColor: '#FFF',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography
                                    variant="h1"
                                    sx={{
                                        height: '64px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    School
                                </Typography>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        height: '64px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    Sign Up as a New School
                                </Typography>
                                <Box sx={{ margin: '16px 0px' }}>
                                    Add a new School to the airTeachr platform
                                </Box>
                                <Box>
                                    <Button
                                        variant="outlined"
                                        onClick={async () => {
                                            await gtag('event', 'conversion', {
                                                'send_to':
                                                    'AW-11074738954/t2MACK658ogYEIq27KAp',
                                                'event_callback':
                                                    window.location,
                                            });
                                            await loginWithRedirect({
                                                scope: `${process.env.REACT_APP_scope} schoolProfile`,
                                                display: 'popup',
                                                screen_hint: 'signup',
                                                redirectUri: `${process.env.REACT_APP_hostUrl}`,
                                                appState: {
                                                    'type': 'school',
                                                    'returnTo':
                                                        '/home?type=school',
                                                },
                                            });
                                        }}
                                    >
                                        School Sign Up
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </div>
    );
};

export default SignUp;
